import React from "react";
import { default as MUIToggleButtonGroup } from "@mui/material/ToggleButtonGroup";
import styled from "styled-components";

const StyledMUIToggleButtonGroup = styled(MUIToggleButtonGroup)`
  height: 48px;
  borderradius: 4px;
`;

export const ToggleButtonGroup = (props) => {
  return <StyledMUIToggleButtonGroup {...props} />;
};
